import React, { Component, Fragment } from 'react';
//import "./details-popup.less";
import Overlay from 'Components/Overlay';
import moment from "moment";


const DetailsPopup = (props) => {

    //const diff = (a, b) => a > b ? a - b : b - a
    const { setShowLanesPopup, laneData  } = props;
    const lanes = laneData.new_lineItem;
    console.log("Lane Data",lanes);
    return(
        <div className="ammendment-popup">
        <Overlay>
        
            <div className="bg-white box-shadow ph-20 pv-20 br-100 pr-40">
                <div className="mb-20 tleft header-medium-color fSemibold fs-18">Approval Details
                <span className="pr-10 fRight" id='close' onClick={ () => setShowLanesPopup(false)}>x</span> 
                </div>
                    <div className="mb-10 tleft white-color bg-theme fSemibold ht-20 fs-16">Contract Dates</div>
                    <div className = "flex pb-10 mb-10 mt--1">
                        <div className = "mb-10 tCenter theme-color fSemibold fs-14 pr-40 col-2">Old Date</div>
                            <div className = "fs-14 header-medium-color col-2">
                                From :{" "}
                                {laneData.contractStartDate !== undefined && laneData.contractStartDate !== 0 && moment(laneData.contractStartDate).format(
                                    "DD-MM-YYYY"
                                )}{" "}
                                <br />
                            </div>
                            <div className = "fs-14 header-medium-color col-2">
                                To :{" "}
                                {laneData.contractEndDate !== undefined && laneData.contractEndDate !== 0 && moment(laneData.contractEndDate).format(
                                    "DD-MM-YYYY"
                                )}{" "}
                                <br />
                            </div>
                    </div>
                        <div className = "flex pb-10 mb-10 mt--1">
                            <div className = "mb-10 tCenter theme-color fSemibold fs-14 pr-40 col-2">New Date</div>
                                <div className = "fs-14 header-medium-color col-2">
                                From :{" "}
                                {laneData.newContractStartDate !== undefined && laneData.newContractStartDate !== 0 && moment(laneData.newContractStartDate).format(
                                    "DD-MM-YYYY"
                                )}{" "}
                                <br />
                            </div>
                            <div className = "fs-14 header-medium-color col-2">
                                To :{" "}
                                {laneData.newContractEndDate !== undefined && laneData.newContractEndDate !== 0 && moment(laneData.newContractEndDate).format(
                                    "DD-MM-YYYY"
                                )}{" "}
                                <br />
                            </div>
                        </div>
                            <div className="mb-10 tleft white-color bg-theme ht-20 fSemibold fs-16">Updated Lanes</div>
                                <div className = "flex pb-10 mb-10 mt--2">
                                <div className = "fBold fs-14 header-medium-color col-1 pl-20">From</div>
                                <div className = "fBold fs-14 header-medium-color col-1 pl-20">To</div>
                                <div className = "fBold fs-14 header-medium-color col-1 pl-20">State</div>
                                <div className = "fBold fs-14 header-medium-color col-1 pl-20">Region</div>
                                <div className = "fBold fs-14 header-medium-color col-1 pl-20">Rate</div>
                            </div>
                            {lanes && lanes.length > 0 ? 
                            <Fragment>
                            {lanes.map((laneVal) => {
                            return(
                                
                                <div className = "flex pb-10 mb-10 mt--2">
                                     <div className = "fs-14 table-text-color col-1 pl-20 break-all">{laneVal.fromLocation && laneVal.fromLocation.split(',')[0] || ''}</div>
                                    <div className = "fs-14 table-text-color col-1 pl-20 break-all">{laneVal.toLocation && laneVal.toLocation.split(',')[0] || ''}</div>
                                    <div className = "fs-14 table-text-color col-1 pl-20 break-all">{laneVal.state}</div>
                                    <div className = "fs-14 table-text-color col-1 pl-20 break-all">{laneVal.region}</div>
                                    <div className = "fs-14 table-text-color col-1 pl-20 break-all">{laneVal.rate}</div>
                                </div>
                            )
                            })}</Fragment> :
                            <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Data Found</div>
                        }
                        
                        </div>
                
              
        </Overlay> 
    </div>

    )
}

export default DetailsPopup;